<template>
  <!-- 栏目管理-->
  <div style="width: 100%; min-height: 600px; border: 10px solid #edeff2">
    <a-spin :spinning="spin">
      <!-- 头部 -->
      <div class="top">
        <span style="color: black; font-size: 14px">分类名称：</span>
        <a-input
          placeholder="请输入"
          style="width: 200px; margin-left: 5px"
          v-model="remark"
        />
        <a-button
          type="primary"
          style="margin-left: 10px; font-size: 14px"
          @click="search"
          >查询</a-button
        >
        <a-button @click="clear" style="margin-left: 20px">重置</a-button>
      </div>
      <!-- 中间 -->
      <div style="width: 100%; height: 10px; background: #edeff2"></div>
      <!-- 列表 -->
      <div class="liebiao">
        <div class="title">分类列表</div>
      </div>
      <div
        :style="{
          width: variables.space_div,
          margin: 'auto',
          paddingTop: variables.LineSpacing,
          paddingBottom: variables.LineSpacing,
        }"
      >
        <a-button type="primary" @click="add">新增</a-button>
      </div>
      <div :style="{ width: variables.space_div, margin: 'auto' }">
        <a-table
          :pagination="false"
          :row-key="(record) => record.id"
          :columns="columnsAdd"
          :dataSource="dataSource"
        >
          <!-- 操作 -->
          <span slot="is_operation" slot-scope="text, record, index">
            <a
              style="margin-right: 10px; font-weight: 550"
              @click="upMove(record)"
              v-show="index === 0 ? false : true"
              >上移</a
            >
            <a
              style="margin-right: 10px; font-weight: 550"
              @click="downMove(record)"
              v-show="index === dataSource.length - 1 ? false : true"
              >下移</a
            >
            <a
              style="margin-right: 10px; font-weight: 550"
              @click="edit(record)"
              >编辑</a
            >
            <!-- <a  style="margin-right:5px; font-weight:550"  @click="editBtn(record.id)">修改</a> -->
            <a-popconfirm
              title="确定删除?"
              ok-text="是"
              cancel-text="否"
              @confirm="del(record)"
              @cancel="cancel"
            >
              <a style="font-weight: 550">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        <template>
          <a-pagination
            v-model="pageNo"
            :total="total"
            show-less-items
            @change="handlepageNo"
          />
        </template>
      </div>

      <!-- -----------------新增对话框 ----------------------------------->
      <a-modal
        title="新增"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-form-model
          :model="form"
          :rules="addRules"
          ref="ruleForm_add"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              v-model="form.name"
              style="display: flex; margin-top: 5px; width: 220px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <!---------------------- 编辑对话框------------------- -->
      <a-modal
        title="编辑"
        :visible="visible1"
        @ok="editOk"
        @cancel="editCancel"
      >
        <a-form-model
          :model="form"
          :rules="addRules"
          ref="ruleForm_edit"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              style="display: flex; margin-top: 5px; width: 220px"
              v-model="form.name"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <!-- 分页 -->
      <!-- <template>
      <a-pagination
        v-model="pageNo"
        :total="total"
        show-less-items
        @change="handlepageNo"
        style="float: right; margin-top: 10px"
      />
    </template> -->
      <MessageAlert
        :visible="visibleAlert"
        v-on:closeMain="closeMainAlert"
      ></MessageAlert>
    </a-spin>
  </div>
</template>

<script>
import variables from "@/assets/base.scss";
import {
  getManagement,
  AddManagement,
  updatedManagement,
  moveManagement,
} from "../../../service/columnmanageapi";
import MessageAlert from "@/components/Authentication/MessageAlert";
import { getAuthenticationInformation } from "@/service/authentication";
export default {
  name: "videoManagement",
  components: { MessageAlert },
  data() {
    return {
      visibleAlert: false,
      userInfoList: {},
      variables,
      spin: false,
      pageNo: 1,
      pageSize: 10,
      visible: false,
      visible1: false,
      remark: "",
      form: {
        name: "",
        code: "1",
      },
      total: 0,
      addform: {},
      dataSource: [],
      addRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[^\s]+[\s]*.*$/i.test(value) == false) {
                callback(new Error("请输入正确的名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      columnsAdd: [
        {
          title: "序号",
          width: "17%",
          key: "num",

          customRender: (text, record, index) =>
            `${(this.pageNo - 1) * this.pageSize + (index + 1)}`,
        },

        {
          title: "名称",
          dataIndex: "title",
          width: "24%",
          key: "title",
        },

        {
          title: "创建人",
          dataIndex: "createdByName",
          width: "20%",
          key: "createdByName",
        },
        {
          title: "创建时间",
          dataIndex: "createdTime",
          width: "23%",
          key: "createdTime",
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "25%",
          scopedSlots: { customRender: "is_operation" },
          key: "operation",
        },
      ],
    };
  },
  created() {
    this.load();
    this.getInformation();
  },
  methods: {
    async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
      } else {
        this.$message.warning("name", response.message);
      }
    },
    // 获取全部数据类型
    load() {
      this.spin = true;
      getManagement({
        type: "video",
        title: this.remark,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.dataSource = res.data;
        this.total = res.count;
        this.spin = false;
      });
    },
    search() {
      this.pageNo = 1;
      this.load();
    },
    // 打开新增
    add() {
      if (this.userInfoList.memberStatus === 0) {
        this.visibleAlert = true;
      } else {
        this.visible = true;
        this.form.name = "";
      }
    },
    // 新增确定
    handleOk() {
      this.spin = true;
      this.$refs.ruleForm_add.validate(async (valid) => {
        if (valid) {
          let form = {
            title: this.form.name,
            type: "video",
          };
          AddManagement(form).then((res) => {
            if (res.code == 200) {
              this.spin = false;
              this.load();
              this.$message.success("新增成功");
              this.visible = false;
              this.form.name = "";
              this.$refs.ruleForm_add.resetFields();
            } else {
              this.$message.warning("新增失败");
              this.load();
              this.$refs.ruleForm_add.resetFields();
            }
          });
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.$refs.ruleForm_add.resetFields();
      this.form.name = "";
      this.spin = false;
    },
    // 打开编辑
    edit(record) {
      this.form.name = record.title;
      this.addform = record;
      this.visible1 = true;
    },

    // 编辑确定
    editOk() {
      this.$refs.ruleForm_edit.validate(async (valid) => {
        if (valid) {
          updatedManagement({
            id: this.addform.id,
            title: this.form.name,
            code: this.addform.code,
            delStatus: 0,
            type: "video",
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success("编辑成功");
              this.visible1 = false;
              this.load();
              this.$refs.ruleForm_edit.resetFields();
              this.form.name = "";
            } else {
              this.$message.warning("编辑失败");
            }
          });
        }
      });
    },
    // 编辑取消
    editCancel() {
      this.visible1 = false;
      this.form.name = "";
      this.form.code = "";
      this.load();
      this.$refs.ruleForm_edit.resetFields();
      this.spin = false;
    },
    // 删除
    del(record) {
      updatedManagement({
        id: record.id,
        title: record.title,
        code: record.code,
        delStatus: 1,
        type: "video",
      }).then((res) => {
        if (res.code == 200) {
          this.load();
          this.$message.success("删除成功");
        } else {
          this.$message.warning("删除失败");
        }
      });
    },
    cancel() {
      this.$message.warning("取消删除");
    },
    clear() {
      (this.remark = ""), this.load();
    },

    //上移
    upMove(record) {
      moveManagement("up", record.id, "video").then((res) => {
        if (res.code == 0) {
          this.load();
          this.$message.success("上移成功");
        } else {
          this.$message.warning("上移失败");
        }
      });
    },
    // 下移
    downMove(record) {
      moveManagement("down", record.id, "video").then((res) => {
        if (res.code == 0) {
          this.load();
          this.$message.success("下移成功");
        } else {
          this.$message.warning("下移失败");
        }
      });
    },

    handlepageNo(pageNo, pageSize) {
      // console.log(pageNo);
      this.load();
    },
    closeMainAlert(val) {
      this.visibleAlert = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-spin-nested-loading {
  width: 100%;
  min-height: 280px;
  height: 100%;
}

.ant-table-thead > tr > th {
  font-size: 17px;
  font-weight: 550;
}
.ant-pagination {
  width: 98%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.top {
  width: $space_div;
  margin: auto;
  height: 60px;
  padding-top: 15px;
}
.liebiao {
  width: 100%;
  border-bottom: 1px solid rgb(238, 233, 233);
  .title {
    color: $topNameColor;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
    width: $space_div;
    margin: auto;
  }
}
</style>
